<template>
    <v-main>
        <v-row class="ma-0">
            <v-col sm="6" class="d-flex align-end justify-end pb-5 pr-5">
                <strong class="white--text">&copy; {{ new Date().getFullYear() }} TCO TEAM.</strong>
            </v-col>
            <v-col sm="6" class="d-flex justify-center align-center">
                <section class="d-flex flex-column align-center">
                    <router-link :to="{name : 'Home'}">
                        <img :src="require('@/../public/images/TcoTeam.png')">
                    </router-link>

                    <h1>Welcome to {{APP_NAME}}</h1>

                    <p class="mb-11">{{$t('auth.description')}}</p>

                    <section class="sectionForm">
                        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                            <v-form @submit.prevent="handleSubmit(submit)">
                                <ValidationProvider vid="email" name="Email" rules="required|email" v-slot="{ errors }">
                                    <v-text-field label="Email"
                                                  type="email"
                                                  v-model="login.email"
                                    >
                                        <template v-slot:prepend-inner>
                                            <svg v-svg="'icon-email'" size="15" class="mr-1"></svg>
                                        </template>
                                    </v-text-field>
                                    <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                </ValidationProvider>

                                <ValidationProvider name="Password" rules="required|min:6" v-slot="{ errors }">
                                    <v-text-field label="Password" type="password"
                                                  v-model="login.password"
                                    >
                                        <template v-slot:prepend-inner>
                                            <svg v-svg="'icon-password'" size="15" class="mr-1"></svg>
                                        </template>
                                    </v-text-field>
                                    <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                </ValidationProvider>

                                <v-card-actions class="justify-center mt-7">
                                    <v-btn class="white--text" color="green" type="submit" :loading="loadingRequest" width="90" height="30">Login</v-btn>
                                </v-card-actions>
                            </v-form>
                        </ValidationObserver>
                    </section>
                </section>

                <v-footer fixed class="d-none transparent mb-3">
                    <strong class="mx-auto">&copy; {{ new Date().getFullYear() }} TCO TEAM.</strong>
                </v-footer>
            </v-col>
        </v-row>
    </v-main>
</template>

<script>
    export default {
        data(){
            return {
                login: {},
                loadingRequest : false,
            }
        },
        methods: {
            submit(){
                this.loadingRequest = true;
                this.$api('auth').loginAdmin(this.login)
                .then(res => {
                    this.$store.dispatch('LOGIN_ADMIN', res.data);
                    this.$router.push({name: 'AdminBlog'});
                }).catch(err => {
                    let response = err.response;
                    if (response.status === 422) this.$refs.form.setErrors(response.data);
                    if (response.status === 302) this.$store.dispatch('alert', {type: 2, message: err.response.data.message});
                }).finally(() => this.loadingRequest = false);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/pages/auth";
</style>